import {Component, Output, OnInit, EventEmitter, Input} from '@angular/core';
import {GameSetUpService} from '../../providers/gameSetUp.service';



@Component({
    selector: 'winner-component',
    templateUrl: './winner.component.html',
    styleUrls: ['./winner.component.scss']
})
export class WinnerComponent implements OnInit {

    @Input() teams: any = undefined;
    @Input() winnerData: any = undefined;
    @Output() nextLeg = new EventEmitter();
    @Output() replay = new EventEmitter();
    @Output() quit = new EventEmitter();

    public legWinner: boolean = false;
    public setWinner: boolean = false;
    public endWinner: boolean = false;

    constructor(public gameSetUpService: GameSetUpService) {
    }

    ngOnInit() {
        if (this.winnerData.end) {
            this.endWinner = true;
        } else {
            if (this.winnerData.setEnd) {
                this.setWinner = true;
            } else {
                this.legWinner = true;
            }
        }

        console.log('winnerData: ', this.winnerData);
        console.log('teams: ', this.teams);
    }

    ngAfterViewInit() {
        // setTimeout(_ => /*code*/ );
    }

    ngOnChanges() {
    }


    getLegWinner(leg?: number) {

        if (leg === undefined) {
            leg = this.winnerData.leg;
        }

        for (let i = 0; i < this.teams.length; i++) {
            if (this.teams[i].sets[this.winnerData.set].legs[leg].win) {
                return i;
            }
        }

    }

    getLegWinnerOfSet() {
        let winnerArr = [];

        for (let i = 0; i < this.gameSetUpService.legs; i++) {
            if (this.getLegWinner(i) !== undefined) {
                winnerArr.push(this.getLegWinner(i));
            }

        }

        console.log('winner of set', winnerArr);
        return winnerArr;
    }

    getSetWinner(set?: number) {

        if (set === undefined) {
            set = this.winnerData.set;
        }

        let setWinner = [];

        let winnerCountArr = [];
        for (let i = 0; i < this.teams.length; i++) {

            for (let k = 0; k < this.teams[i].sets[set].legs.length; k++) {
                if (this.teams[i].sets[set].legs[k].win) {

                    if (winnerCountArr[i] !== undefined) {
                        winnerCountArr[i] = winnerCountArr[i] + 1;
                    } else {
                        winnerCountArr[i] = 1;
                    }
                }

            }
        }

        //fill empty values
        for (let i = 0; i < this.gameSetUpService.teamCount; i++) {
            if (winnerCountArr[i] === undefined) {
                winnerCountArr[i] = 0;
            }
        }

        console.log('setWinner: ', winnerCountArr.indexOf(Math.max.apply(Math, winnerCountArr)));

        let highestValue = winnerCountArr[winnerCountArr.indexOf(Math.max.apply(Math, winnerCountArr))];

        for (let i = 0; i < winnerCountArr.length; i++) {
            if (winnerCountArr[i] === highestValue) {
                setWinner.push(i);
            }
        }

        return setWinner;

    }

    getGameWinner() {
        let gameWinner = [];

        let gameWinnerCountArr = [];
        console.log('-----');

        for (let i = 0; i < this.gameSetUpService.sets; i++) {

            let setWinner = this.getSetWinner(i);
            console.log('game setWinner: ', setWinner);
            if (setWinner.length > 1) {

                for (let k = 0; k < setWinner.length; k++) {
                    if (gameWinnerCountArr[setWinner[k]] !== undefined) {
                        gameWinnerCountArr[setWinner[k]] = gameWinnerCountArr[k] + 1;
                    } else {
                        gameWinnerCountArr[setWinner[k]] = 1;
                    }
                }

            } else {
                if (gameWinnerCountArr[setWinner[0]] !== undefined) {
                    gameWinnerCountArr[setWinner[0]] = gameWinnerCountArr[setWinner[0]] + 1;
                } else {
                    gameWinnerCountArr[setWinner[0]] = 1;
                }
            }

        }

        let highestValue = gameWinnerCountArr[gameWinnerCountArr.indexOf(Math.max.apply(Math, gameWinnerCountArr))];

        for (let i = 0; i < gameWinnerCountArr.length; i++) {
            if (gameWinnerCountArr[i] === highestValue) {
                gameWinner.push(i);
            }
        }

        console.log('game Winner: ', gameWinnerCountArr);

        return gameWinner;

    }





    countUpWinnerOrderedList() {
        let teamArray = [];

        for (let i = 0; i < this.teams.length; i++) {
            teamArray.push({
                name: this.teams[i].name,
                id: this.teams[i].id,
                points: this.calcPoints(this.teams[i].sets[0].legs[0])
            });
        }

        teamArray.sort(function (a, b) {
            if (a.points < b.points) {
              return 1;
            }
            if (a.points > b.points) {
              return -1;
            }
            return 0;
        });

        return teamArray;
    }


    calcPoints(teamData) {
        if (this.gameSetUpService.gameMode === 'count-up') {
            let sum = teamData.scores.reduce(function(pv, cv) { return pv + cv; }, 0);
            return sum;
        }
    }


}



// WEBPACK FOOTER //
// ./src/app/components/winner/winner.component.ts